const blurTarget = (event: any) => {
  event.target instanceof HTMLElement && event.target.blur();
};

export default blurTarget;
